import { useEffect, useRef } from "react";
import axios from "axios";
import { databaseURL } from "../helpers.js";

/**
 * Enregistre côté serveur la langue de l'interface (29/09/2026), pour que les notifications push
 * soient écrites dans la langue que le compte a choisie. Envoyée une seule fois par couple
 * (compte connecté, langue) : à l'ouverture de l'application, à la connexion et à chaque
 * changement de langue. Un échec est silencieux — c'est un confort, jamais une condition — et
 * autorise une nouvelle tentative au prochain rendu.
 */
export default function useSynchroniserLangue(langue, token) {
  const derniereEnvoyee = useRef(null);

  useEffect(() => {
    if (!token || (langue !== "fr" && langue !== "en")) return;
    const cle = `${token}:${langue}`;
    if (derniereEnvoyee.current === cle) return;
    derniereEnvoyee.current = cle;
    axios
      .put(databaseURL + "users/langue", { langue }, { headers: { Authorization: `Bearer ${token}` } })
      .catch(() => {
        derniereEnvoyee.current = null;
      });
  }, [langue, token]);
}
